import { getEnvironment } from './env/environment';

const apiVersion = 'v1';
const baseUri = `/loy/api/bonus-points/${apiVersion}`;
const monitoringUri = `/loy/api/monitoring/v1`;

const contenfulBaseUrl =
  getEnvironment() === 'prod'
    ? 'https://content-bff.cmsp.ext.aws.zooplus.io'
    : 'https://content-bff-qa.cmsd.ext.aws.zooplus.io';

const loyaltyProgramBaseUrl =
  getEnvironment() === 'prod'
    ? 'https://loyalty-management-public-bff.private.zooplus.net'
    : 'https://loyalty-management-public-bff-dev.private.zooplus.net';

export default {
  APP_NAME: 'bonus-points-web-components',
  PRODUCT_NAME: 'bonus-points',
  RENDER_TIMEOUT: 5000,
  COMPONENT_NAME: {
    FORECAST_BOX: 'forecast-box',
    TERMS_AND_CONDITIONS: 'terms-and-conditions',
    ACCOUNT_NAVIGATION_BOX: 'account-navigation-box',
    REWARD_SHOP: 'reward-shop',
    DONATIONS_PDP: 'donations-pdp',
    OVERVIEW: 'overview',
    LIGHT_ACCOUNT_NAVIGATION_BOX: 'light-account-navigation-box',
    PUBLIC_MENU: 'public-menu',
    PDP: 'pdp',
  },
  COMPONENT_LOCATION: {
    FORECAST_BOX: 'Checkout',
    TERMS_AND_CONDITIONS: 'TermsAndConditions',
    REWARD_SHOP: 'MyAccount',
    DONATIONS_PDP: 'MyAccount',
    OVERVIEW: 'MyAccount',
    LIGHT_ACCOUNT_NAVIGATION_BOX: 'MyAccount',
    PUBLIC_MENU: 'MyAccount',
    PDP: 'MyAccount',
  },
  API: {
    TIMEOUT: 10000,
    URI: {
      LOGS: `${baseUri}/logs`,
      METRICS: `${monitoringUri}/metrics`,
      LOC_RESOURCES: `${baseUri}/loc-resources`,
      FORECAST: `${baseUri}/customers/balance-forecast`,
      ACCOUNT_NAVIGATION_BOX: `${baseUri}/customers`,
      MY_ZOOPLUS_BOX: `${baseUri}/customers`,
      REWARD_SHOP: `${baseUri}/reward-shop/overview`,
      ENTRIES: `${baseUri}/customers/entries`,
      EXCHANGE_RATE: `${baseUri}/reward-shop/exchange-rate`,
      LOYALTY_PROGRAM_TOGGLE: `${loyaltyProgramBaseUrl}/v1/toggles/membership/site/{siteId}`,
      TERMS_AND_CONDITIONS: `${contenfulBaseUrl}/static-page-legal/v1/{siteDomain}/{locale}/bonus_points_terms`,
    },
    VARIABLE: {
      BALANCE: 'balance',
    },
  },
  EVENT: {
    AUTH: {
      SUCCESS: 'AUTH-SUCCESS-EVENT-v1',
    },
    CART: {
      ADD_TO_CART: 'ADD-TO-CART-v1',
      ADD_TO_CART_SUCCESS: 'ADD-TO-CART-SUCCESS-v1',
      ADD_TO_CART_FAILURE: 'ADD-TO-CART-FAILURE-v1',
      GET_CART: 'GET-CART-v1',
      GET_CART_SUCCESS: 'GET-CART-SUCCESS-v1',
      GET_CART_FAILURE: 'GET-CART-FAILURE-v1',
      UPDATE_ADOBE: 'UPDATE-ADOBE-v1',
    },
    BALANCE: {
      GET_BALANCE: 'GET-BALANCE-v1',
      GET_BALANCE_SUCCESS: 'GET-BALANCE-SUCCESS-v1',
      GET_BALANCE_FAILURE: 'GET-BALANCE-FAILURE-v1',
    },
    FORECAST_BOX: {
      ERROR: 'BONUS-POINTS-FORECAST-BOX-ERROR-v1',
    },
  },
};
